// third-party
import _ from 'lodash';
import $ from 'jquery';
import { LocalDate } from '@js-joda/core';
import React, { Component, ReactComponentElement } from 'react';
import { ButtonSecondary, ButtonTertiary, Checkbox, IconProcessing } from '@americanexpress/dls-react';

// models and services
import { IncomeSourceModel } from 'src/types/income-source.model';
import { PersonModel, RelationshipType } from 'src/types/person.model';
import { MortgageType } from 'src/types/real-estate.model';
import { RecurringExpenseModel } from 'src/types/recurring-expense.model';
import { CardStyleType } from 'src/types/card-type.enum';
import CardService from 'src/services/card.service';
import FinanceService from 'src/services/finance.service';
import IncomeSourceService from 'src/services/income-source.service';
import LiteralsService from 'src/services/literals/LiteralsService';
import MixpanelService from 'src/services/mixpanel.service';
import PersonService from 'src/services/person.service';
import RecurringExpenseService from 'src/services/recurring-expense.service';
import UserService from 'src/services/user.service';
import { CardModel } from 'src/types/card.model';
import { OTHER_INCOME, PRIMARY_BUTTON_SELECTOR, StartupSteps } from 'src/types/onboarding.enum';
import { HELP_DOMAIN, PRIVACY_POLICY, PRODUCT_NAME, TERMS_AND_CONDITIONS } from 'src/utils/constants';

// components
import Callout from 'src/components/callout/Callout';
import WideView from 'src/components/atomic/layouts/wideView/WideView';
import ChoiceCard from 'src/components/choice-card/ChoiceCard';
import { goalIcons } from 'src/bw/goal/Goal';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Drawer from 'src/components/drawer/Drawer';

// views
import Welcome from './views/welcome/Welcome';
import Who from './views/who/Who';
import Whoelse from './views/whoelse/Whoeelse';
import MeetYourPlan from './views/meetYourPlan/MeetYourPlan';
import Incomes from './views/incomes/Incomes';
import Expenses from './views/expenses/Expenses';

import bgColors from 'src/styles/bgColors.module.scss';
import './OnboardingDrawer.scss'; // TODO delete this file
import CashAndBankingAccountListAccountsView from '../listAccounts/CashAndBanking/CashAndBankingListAccountsView';
import InvestmentsAndRetirementListAccountsView from '../listAccounts/investmentsAndRetirement/InvestmentsAndRetirementListAccountsView';
import PropertyAndAssetsListAccountsView from '../listAccounts/propertyAndAssets/PropertyAndAssetsListAccountsView';
import LoansAndDebtsListAccountsView from '../listAccounts/loansAndDebts/LoansAndDebtsListAccountsView';
import GlobalHeader from 'src/components/navigation/GlobalHeader';

export interface OnboardingGoal {
    label: string;
    iconName: string;
    description: string;
    track: string;
    cname: string;
}

const onboardingGoals: OnboardingGoal[] = [
    {
        label: LiteralsService.getLiteral('Onboarding.largePurchase.label'),
        iconName: LiteralsService.getLiteral('Onboarding.largePurchase.iconName'),
        description: LiteralsService.getLiteral('Onboarding.largePurchase.description'),
        track: LiteralsService.getLiteral('Onboarding.largePurchase.track'),
        cname: LiteralsService.getLiteral('Onboarding.largePurchase.cname')
    },
    {
        label: LiteralsService.getLiteral('Onboarding.planEducation.label'),
        iconName: LiteralsService.getLiteral('Onboarding.planEducation.iconName'),
        description: LiteralsService.getLiteral('Onboarding.planEducation.description'),
        track: LiteralsService.getLiteral('Onboarding.planEducation.track'),
        cname: LiteralsService.getLiteral('Onboarding.planEducation.cname')
    },
    {
        label: LiteralsService.getLiteral('Onboarding.buyHouse.label'),
        iconName: LiteralsService.getLiteral('Onboarding.buyHouse.iconName'),
        description: LiteralsService.getLiteral('Onboarding.buyHouse.description'),
        track: LiteralsService.getLiteral('Onboarding.buyHouse.track'),
        cname: LiteralsService.getLiteral('Onboarding.buyHouse.cname')
    },
    {
        label: LiteralsService.getLiteral('Onboarding.planRetirement.label'),
        iconName: LiteralsService.getLiteral('Onboarding.planRetirement.iconName'),
        description: LiteralsService.getLiteral('Onboarding.planRetirement.description'),
        track: LiteralsService.getLiteral('Onboarding.planRetirement.track'),
        cname: LiteralsService.getLiteral('Onboarding.planRetirement.cname')
    },
    {
        label: LiteralsService.getLiteral('Onboarding.takeVacation.label'),
        iconName: LiteralsService.getLiteral('Onboarding.takeVacation.iconName'),
        description: LiteralsService.getLiteral('Onboarding.takeVacation.description'),
        track: LiteralsService.getLiteral('Onboarding.takeVacation.track'),
        cname: LiteralsService.getLiteral('Onboarding.takeVacation.cname')
    },
    {
        label: LiteralsService.getLiteral('Onboarding.growFamily.label'),
        iconName: LiteralsService.getLiteral('Onboarding.growFamily.iconName'),
        description: LiteralsService.getLiteral('Onboarding.growFamily.description'),
        track: LiteralsService.getLiteral('Onboarding.growFamily.track'),
        cname: LiteralsService.getLiteral('Onboarding.growFamily.cname')
    }
];

export const PlaidContext = React.createContext({
    handleClearFirstImport: () => {},
    handleFirstImport: () => {},
    handleReloadUser: () => {},
    firstImport: {},
    user: {},
    showLoader: () => {},
    hideLoader: () => {},
    handleTopDrawer: () => {},
    handleAccounts: () => {}
});

export default class OnboardingDrawer extends Component<any> {
    public birthLocal: LocalDate;
    public birthDate: LocalDate = LocalDate.now().minusYears(30);
    public wideViewStartupSteps: StartupSteps[] = [StartupSteps.WELCOME, StartupSteps.WHO, StartupSteps.WHOELSE];

    public override state = {
        name: '',
        dob: null as LocalDate,
        invalidDate: false,
        isImageEditing: false,
        currentPerson: null as PersonModel,
        openPersonDialog: false,
        incomes: _.get(this, 'props.user.attributes.startupIncomes', []),
        startupStep: _.get(this, 'props.user.attributes.startupStep', 0),
        startupGoals: _.get(this, 'props.user.attributes.startupGoals', []),
        assetName: '',
        assetAmount: 0,
        addManual: false,
        manualTitle: '',
        manualType: '',
        balance: 0,
        mortgageType: 'mortgage_none' as MortgageType,
        startupSteps: _.get(this, 'props.user.attributes.startupSteps', []),
        mortgageDate: null as LocalDate,
        mortgageInterest: 0,
        mortgagePayment: 0,
        age: 0
    };

    public static getDerivedStateFromProps(props: any, prevState: any): any {
        if (props.user.attributes.startupStep !== prevState.startupStep) {
            return {
                ...prevState,
                startupStep: props.user.attributes.startupStep
            };
        }
        return prevState;
    }

    public override componentDidUpdate(): void {
        // if no focus, focus on the primary button
        if (document.activeElement === document.body || document.activeElement === null) {
            $('.onboarding-drawer .primaryButton').focus();
        }
    }

    public override render(): ReactComponentElement<any> {
        let stepDiv: JSX.Element;
        let yourPerson: PersonModel = null;

        if (this.props.drawerProps.persons) {
            yourPerson = PersonService.you(this.props.drawerProps.persons);
        }

        switch (this.state.startupStep) {
            case StartupSteps.WELCOME:
                stepDiv = (
                    <Welcome
                        getGoalCard={this.getGoalCard.bind(this)}
                        onboardingGoals={onboardingGoals}
                        startupGoals={this.state.startupGoals}
                        welcomeNext={this.welcomeNext.bind(this)}
                    />
                );
                break;

            case StartupSteps.WHO:
                stepDiv = (
                    <Who
                        handleUpdateUserAttribute={this.props.handleUpdateUserAttribute.bind(this)}
                        next={this.next.bind(this)}
                        back={this.back.bind(this)}
                    />
                );
                break;

            case StartupSteps.WHOELSE:
                stepDiv = (
                    <Whoelse
                        currentPerson={this.state.currentPerson}
                        openPersonDialog={this.state.openPersonDialog}
                        updatePersons={this.updatePersons.bind(this)}
                        user={this.props.user}
                        updateUserLocally={this.props.updateUserLocally.bind(this)}
                        updatePerson={this.updatePerson.bind(this)}
                        setState={this.setState.bind(this)}
                        persons={this.props.drawerProps.persons}
                        startAddPerson={this.startAddPerson.bind(this)}
                        back={this.back.bind(this)}
                        whoElseNext={this.whoElseNext.bind(this)}
                    />
                );
                break;

            case StartupSteps.MEET_YOUR_PLAN:
                stepDiv = (
                    <MeetYourPlan
                        yourPerson={yourPerson}
                        back={this.back.bind(this)}
                        meetYourPlanNext={this.next.bind(this)}
                        drawerProps={this.props.drawerProps}
                    />
                );
                break;

            case StartupSteps.INCOMES:
                stepDiv = (
                    <Drawer
                        drawerProps={{ history }}
                        withBackButton
                        handleBack={() => {
                            void this.back();
                        }}
                        title={LiteralsService.getLiteral('Onboarding.incomes.header')}
                    >
                        <Incomes
                            user={this.props.user}
                            persons={
                                (this.props.drawerProps.persons as PersonModel[])?.filter(
                                    ({ relationship }) => relationship !== RelationshipType.Child
                                ) || []
                            }
                            incomes={this.state.incomes}
                            handleReloadUser={this.props.handleReloadUser.bind(this)}
                            updateIncomes={this.updateIncomes.bind(this)}
                            next={this.next.bind(this)}
                        />
                    </Drawer>
                );
                break;

            case StartupSteps.EXPENSES: {
                stepDiv = (
                    <Expenses
                        user={this.props.user}
                        back={this.back.bind(this)}
                        drawerProps={this.props.drawerProps}
                        handleReloadUser={this.props.handleReloadUser.bind(this)}
                        setExpenses={this.setExpenses.bind(this)}
                        persons={this.props.drawerProps.persons}
                        expensesNext={this.next.bind(this)}
                    />
                );
                break;
            }

            case StartupSteps.CASH_AND_BANKING:
                stepDiv = (
                    <CashAndBankingAccountListAccountsView
                        user={this.props.user}
                        back={this.back.bind(this)}
                        next={this.next.bind(this)}
                        handleReloadUser={this.props.handleReloadUser.bind(this)}
                    />
                );
                break;

            case StartupSteps.RETIREMENT:
                stepDiv = (
                    <InvestmentsAndRetirementListAccountsView
                        user={this.props.user}
                        back={this.back.bind(this)}
                        next={this.next.bind(this)}
                        handleReloadUser={this.props.handleReloadUser.bind(this)}
                    />
                );
                break;

            case StartupSteps.PROPERTY_AND_ASSETS:
                stepDiv = (
                    <PropertyAndAssetsListAccountsView
                        user={this.props.user}
                        back={this.back.bind(this)}
                        next={this.next.bind(this)}
                        handleReloadUser={this.props.handleReloadUser.bind(this)}
                    />
                );
                break;

            case StartupSteps.LOANS_AND_DEBTS:
                stepDiv = (
                    <LoansAndDebtsListAccountsView
                        user={this.props.user}
                        back={this.back.bind(this)}
                        next={this.next.bind(this)}
                        handleReloadUser={this.props.handleReloadUser.bind(this)}
                    />
                );
                break;

            case StartupSteps.SAVE:
                stepDiv = <>{this.getLogin(true)}</>;
                break;

            default:
                stepDiv = null;
                break;
        }

        return (
            <PlaidContext.Provider
                value={{
                    handleClearFirstImport: this.props.handleClearFirstImport,
                    handleFirstImport: this.props.handleFirstImport,
                    handleReloadUser: this.props.handleReloadUser,
                    firstImport: this.props.firstImport,
                    user: this.props.user,
                    showLoader: this.props.showLoader,
                    hideLoader: this.props.hideLoader,
                    handleTopDrawer: this.props.handleTopDrawer,
                    handleAccounts: this.props.handleAccounts
                }}
            >
                {this.state.startupStep in this.wideViewStartupSteps ? (
                    <>
                        <GlobalHeader />
                        <div className={`step${this.state.startupStep}`}>{stepDiv}</div>
                    </>
                ) : (
                    <WideView
                        classNameView="onboarding-drawer"
                        classNameContainer={bgColors.backgroundLight}
                        hideBackButton
                    >
                        <div className={`step${this.state.startupStep}`}>{stepDiv}</div>
                    </WideView>
                )}
            </PlaidContext.Provider>
        );
    }

    private getGoalCard(startupGoals: string[], goal: OnboardingGoal, index: number): JSX.Element {
        const type: string = startupGoals.includes(goal.label) ? CardStyleType.SPECIAL : CardStyleType.STANDARD;
        const key: string = `goal-${index || 0}`;

        return (
            <ChoiceCard
                label={goal.label}
                description={goal.description}
                icon={goalIcons[goal.iconName]}
                type={type}
                key={key}
                onClick={async () => await this.selectGoal(goal)}
            />
        );
    }

    private async next(): Promise<void> {
        let nextStep: number;
        if (this.state.startupSteps.length) {
            const index: number = this.state.startupSteps.indexOf(this.state.startupStep);
            if (this.state.startupStep === StartupSteps.WHO && this.props.user.attributes.startupJustMe) {
                await this.nextAfterJustMe();
                return;
            }
            nextStep = this.state.startupSteps[index + 1];
        } else {
            nextStep = StartupSteps.WHO;
        }
        await this.goto(nextStep);
    }

    private async goto(step: StartupSteps): Promise<void> {
        await this.handleStep(step);

        if (step === StartupSteps.DONE) return;

        const attributes: any = this.props.user.attributes;
        if (!attributes.startupStepsDone) {
            attributes.startupStepsDone = [attributes.startupStep];
        } else {
            attributes.startupStepsDone.push(attributes.startupStep);
        }
        attributes.startupStep = step;
        await this.props.handleUpdateUserAttributes(attributes);
        this.setState({
            startupStep: step
        });
    }

    private async handleStep(step: StartupSteps): Promise<void> {
        switch (step) {
            case StartupSteps.WHO:
                await this.setStartupSteps();
                break;

            case StartupSteps.INCOMES:
                if (this.props.user.attributes.startupDragGoal) {
                    await this.props.handleClearUserAttribute('startupDragGoal');
                    MixpanelService.track('o4 Life event moved - no');
                } else {
                    MixpanelService.track('o4 Life event moved - yes');
                }
            // falls through
            case StartupSteps.WHOELSE:
            case StartupSteps.MEET_YOUR_PLAN:
                await this.refreshPersons();
                break;
            case StartupSteps.EXPENSES:
                this.props.handleView('income-expense');
                break;
            case StartupSteps.SAVE:
                if (!this.props.user.temporary) {
                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                    window.setTimeout(this.next.bind(this), 10);
                }
                break;
            case StartupSteps.DONE:
                const attributes: any = this.props.user.attributes;
                delete attributes.startupStep;
                delete attributes.startupSteps;
                delete attributes.startupGoals;
                delete attributes.startupJustMe;
                delete attributes.startupIncomes;
                delete attributes.startupStepsDone;
                delete attributes.startupShowIncome;
                delete attributes.startupShowExpenses;
                delete attributes.startupShowAssets;
                delete attributes.startupDragGoal;
                await this.props.handleUpdateUserAttributes(attributes);
                const holdings: number = this.props.user.holdings.length;
                const accounts: number = this.props.user.accounts.length;
                MixpanelService.track(`o4 ${holdings + accounts} accounts (${holdings} manual, ${accounts} connected)`);
                this.props.processAction('into-bodeswell-1');
                this.props.updateStartStep(null);
        }
    }

    private async back(): Promise<void> {
        const startupStepsDone: number[] = this.props.user.attributes.startupStepsDone;
        const nextStep: number = startupStepsDone.pop();

        const attributes: any = this.props.user.attributes;
        attributes.startupStep = nextStep;
        attributes.startupStepsDone = startupStepsDone;
        await this.props.handleUpdateUserAttributes(attributes);

        await this.handleStep(nextStep);

        this.setState({
            startupStep: nextStep
        });
    }

    private async selectGoal(goal: OnboardingGoal): Promise<void> {
        const startupGoals: string[] = this.state.startupGoals;

        if (startupGoals.includes(goal.label)) {
            startupGoals.splice(startupGoals.indexOf(goal.label), 1);
        } else {
            startupGoals.push(goal.label);
        }

        this.setState({
            startupGoals
        });
        await this.props.handleUpdateUserAttribute('startupGoals', startupGoals);
    }

    public handleChange(value: any, name: string): void {
        const newState: any = { ...this.state };
        newState[name] = value;
        this.setState(newState);
    }

    private updatePerson(person: PersonModel): void {
        this.setState({
            currentPerson: person
        });
    }

    private async updatePersons(): Promise<void> {
        this.setState({
            openPersonDialog: false,
            currentPerson: null,
            showRequired: false
        });

        await this.refreshPersons();
    }

    private startAddPerson(): void {
        const person = new PersonModel();
        person.nickname = '';
        person.dob = LocalDate.now();
        person.isDependent = false;

        this.setState({
            openPersonDialog: true,
            currentPerson: person
        });
    }

    private async updateIncomes(newIncomes: { [key: string]: any }, plaidConnected: boolean): Promise<void> {
        if (!plaidConnected) {
            MixpanelService.track('o4 Add Income Complete');
            $(PRIMARY_BUTTON_SELECTOR).prop('disabled', true);
            const attributes: any = this.props.user.attributes;
            attributes.startupIncomes = newIncomes;
            attributes.startupShowIncome = true;
            await this.props.handleUpdateUserAttributes(attributes);
            const income: number = _.sumBy(Object.keys(newIncomes), (key) => newIncomes[key]);
            await this.props.handleUpdateUserAttribute('stepZeroIncome', income);
            await this.deleteOldIncomes();
            const incomeSources = await IncomeSourceService.getIncomeSources();

            for (const key of Object.keys(newIncomes)) {
                const personIncome = newIncomes[key];
                let person: PersonModel = null;
                if (key !== OTHER_INCOME) person = _.find(this.props.drawerProps.persons, { nickname: key });
                await this.setIncomeForPerson(incomeSources, person, personIncome);
            }

            this.setState({ ...this.state, incomes: newIncomes });
        } else {
            // if plaid is connected: show incomes on the graph
            const attributes: any = this.props.user.attributes;
            attributes.startupShowIncome = true;
            await this.props.handleUpdateUserAttributes(attributes);
        }

        await this.props.handleReloadUser();
        $(PRIMARY_BUTTON_SELECTOR).prop('disabled', false);
    }

    private async deleteOldIncomes(): Promise<void> {
        const incomes = await IncomeSourceService.getIncomeSources();
        const promises: Array<Promise<any>> = [];

        try {
            const keys = Object.keys(this.state.incomes);
            for (const income of incomes) {
                if (income.userCreated && !keys.includes(income.name)) {
                    promises.push(IncomeSourceService.deleteIncomeSource(income));
                }
            }
        } catch (e: any) {}

        await Promise.all(promises);
    }

    private async retireIncome(person: PersonModel, incomes: IncomeSourceModel[]): Promise<IncomeSourceModel> {
        let currentIncome: IncomeSourceModel = _.find(incomes, { name: person.nickname });

        if (!currentIncome) {
            currentIncome = new IncomeSourceModel();
            currentIncome.annualizedIncome = 75000;
            currentIncome.name = person.nickname;
            currentIncome = await IncomeSourceService.createIncomeSource(currentIncome);
        }

        return currentIncome;
    }

    private async retire(person: PersonModel, currentIncome: IncomeSourceModel, y: number): Promise<CardModel> {
        const startDate: LocalDate = PersonService.getRetireAge(person);
        return await CardService.createCard(
            {
                description: 'retire',
                nickname: LiteralsService.getLiteral('Onboarding.goalRetire', [person.nickname]),
                startDate,
                endDate: startDate,
                attributes: {},
                accountId: null,
                startIncomes: [],
                modifyIncomes: [currentIncome.incomeUid],
                yPosition: y,
                createdBy: 'onboarding'
            },
            this.props.user,
            false,
            true
        );
    }

    private async educate(person: PersonModel, y: number): Promise<CardModel> {
        const startDate: LocalDate = PersonService.getEducateAge(person);
        const endDate: LocalDate = startDate.plusYears(4);
        return await CardService.createCard(
            {
                description: 'plan for education costs',
                nickname: LiteralsService.getLiteral('Onboarding.goalEducation', [person.nickname]),
                startDate,
                endDate,
                attributes: {
                    financialAid: 50000,
                    roomBoard: 50000,
                    totalAmount: -42000,
                    isPublic: 'true',
                    inState: 'true'
                },
                accountId: null,
                startIncomes: [],
                modifyIncomes: [],
                yPosition: y,
                createdBy: 'onboarding'
            },
            this.props.user,
            false,
            true
        );
    }

    private async setIncomeForPerson(incomes: IncomeSourceModel[], person: PersonModel, amount: number): Promise<void> {
        let currentIncome: IncomeSourceModel = _.find(incomes, { name: person ? person.nickname : OTHER_INCOME });
        if (!currentIncome) {
            currentIncome = new IncomeSourceModel();
        }

        // adjust for taxes according to https://www.nerdwallet.com/article/taxes/federal-income-tax-brackets
        // TODO ?? Do not modify this without updating Elephant's "delete initial values after sync" StepZero code
        const taxOwed: number = FinanceService.incomeTaxAmount(amount);
        currentIncome.annualizedIncome = amount - taxOwed;
        currentIncome.name = person ? person.nickname : OTHER_INCOME;

        if (currentIncome.incomeUid) {
            await IncomeSourceService.updateIncomeSource(currentIncome);
        } else {
            await IncomeSourceService.createIncomeSource(currentIncome);
        }
    }

    private async setExpenses(expenses: number, name: string = 'Recurring Expense'): Promise<void> {
        const promises: Array<Promise<any>> = [];
        promises.push(UserService.deleteAttribute('hideExpenses'));

        // delete old expenses if any
        const expenseList = await RecurringExpenseService.getRecurringExpenses();
        for (const expense of expenseList) {
            promises.push(RecurringExpenseService.deleteRecurringExpense(expense));
        }

        const attributes: any = this.props.user.attributes;
        attributes.stepZeroExpenses = expenses;
        attributes.startupShowExpenses = true;
        promises.push(this.props.handleUpdateUserAttributes(attributes));
        await Promise.all(promises);

        await this.makeExpenses(expenses, name);
        $(PRIMARY_BUTTON_SELECTOR).prop('disabled', false);
    }

    private async addGoals(): Promise<void> {
        let startDate: LocalDate;
        let endDate: LocalDate;
        let promises: Array<Promise<any>> = [];
        let y: number = 0.01;
        const yDelta: number = 0.22;

        if (this.props.user.attributes.startupJustMe) {
            // do I have other people, the user must have gone back
            if (_.has(this.props.drawerProps, 'persons')) {
                _(this.props.drawerProps.persons)
                    .filter((person: PersonModel) => person.relationship !== 'self')
                    .forEach((person: PersonModel) => {
                        promises.push(PersonService.deletePerson(person));
                    });
            }
            if (promises.length) {
                await Promise.all(promises);
                await this.refreshPersons();
                promises = [];
            }
        }

        // delete all old goals, oddly this list is not always deduped
        const uniqCards: CardModel[] = _.uniqBy(this.props.user.cards, function (c: CardModel) {
            return c.id;
        });
        for (const card of uniqCards) {
            promises.push(CardService.deleteCard(card));
        }
        await Promise.all(promises);
        promises = [];

        const yourPerson: PersonModel = _.find(this.props.drawerProps.persons, { relationship: 'self' });
        let incomes = await IncomeSourceService.getIncomeSources();

        // breadwinners make 100k unless incomes are already set
        if (!this.props.user.attributes.startIncomes && _.has(this.props.drawerProps, 'persons')) {
            _(this.props.drawerProps.persons).forEach((person: PersonModel) => {
                switch (person.relationship) {
                    case 'self':
                    case 'partner':
                    case 'spouse':
                        promises.push(this.setIncomeForPerson(incomes, person, 100000));
                        break;
                }
            });
        }
        await Promise.all(promises);
        promises = [];

        incomes = await IncomeSourceService.getIncomeSources();

        const goals = this.state.startupGoals;
        if (goals) {
            for (const goal of goals) {
                switch (goal) {
                    case 'Make a large purchase':
                        startDate = LocalDate.now().plusYears(2);
                        endDate = startDate;
                        promises.push(
                            CardService.createCard(
                                {
                                    description: LiteralsService.getLiteral('Onboarding.largePurchase.cardDescription'),
                                    startDate,
                                    endDate,
                                    attributes: {
                                        totalAmount: -5000,
                                        purchaseName: 'large purchase'
                                    },
                                    accountId: null,
                                    startIncomes: [],
                                    modifyIncomes: [],
                                    yPosition: y,
                                    createdBy: 'onboarding'
                                },
                                this.props.user,
                                false,
                                true
                            )
                        );
                        y = (y + yDelta) % 1;
                        break;

                    case 'Plan for education expenses':
                        let education = 0;
                        for (const person of this.props.drawerProps.persons) {
                            switch (person.relationship) {
                                case 'child':
                                    promises.push(this.educate(person, y));
                                    y = (y + yDelta) % 1;
                                    education++;
                                    break;
                            }
                        }
                        if (!education) {
                            promises.push(this.educate(yourPerson, y));
                            y = (y + yDelta) % 1;
                        }
                        break;

                    case 'Buy a house':
                        startDate = LocalDate.now().plusYears(5);
                        endDate = startDate;
                        promises.push(
                            CardService.createCard(
                                {
                                    description: LiteralsService.getLiteral('Onboarding.buyHouse.cardDescription'),
                                    startDate,
                                    endDate,
                                    attributes: {
                                        down_payment_percent: 20,
                                        purchase_price: 500000,
                                        renovation_budget: 0,
                                        down_payment: 100000,
                                        mortgage_type: 30,
                                        mortgage_interest: 3.85,
                                        property_tax: 0,
                                        property_insurance: 0,
                                        borrowing: 0,
                                        monthly_payment: 0
                                    },
                                    accountId: null,
                                    startIncomes: [],
                                    modifyIncomes: [],
                                    yPosition: y,
                                    createdBy: 'onboarding'
                                },
                                this.props.user,
                                false,
                                true
                            )
                        );
                        y = (y + yDelta) % 1;
                        break;

                    case 'Take a vacation':
                        startDate = LocalDate.now().plusYears(1);
                        endDate = startDate;
                        promises.push(
                            CardService.createCard(
                                {
                                    description: LiteralsService.getLiteral('Onboarding.takeVacation.cardDescription'),
                                    startDate,
                                    endDate,
                                    attributes: {
                                        totalAmount: -2000
                                    },
                                    accountId: null,
                                    startIncomes: [],
                                    modifyIncomes: [],
                                    yPosition: y,
                                    createdBy: 'onboarding'
                                },
                                this.props.user,
                                false,
                                true
                            )
                        );
                        y = (y + yDelta) % 1;
                        break;

                    case 'Grow a family':
                        startDate = LocalDate.now().plusYears(2);
                        endDate = startDate.plusYears(18);

                        promises.push(
                            CardService.createCard(
                                {
                                    description: LiteralsService.getLiteral('Onboarding.growFamily.cardDescription'),
                                    startDate,
                                    endDate,
                                    attributes: {
                                        totalAmount: -250000
                                    },
                                    accountId: null,
                                    startIncomes: [],
                                    modifyIncomes: [],
                                    yPosition: y,
                                    createdBy: 'onboarding'
                                },
                                this.props.user,
                                false,
                                true
                            )
                        );
                        y = (y + yDelta) % 1;
                        break;
                }
            }

            const newIncomes: { [key: string]: any } = {};

            // do retirement last
            for (const goal of goals) {
                switch (goal) {
                    case 'Plan for retirement':
                        for (const person of this.props.drawerProps.persons) {
                            switch (person.relationship) {
                                case 'self':
                                case 'partner':
                                case 'spouse':
                                    const currentIncome = await this.retireIncome(person, incomes);
                                    newIncomes[person.nickname] = currentIncome;
                                    await this.retire(person, currentIncome, y);

                                    y = (y + yDelta) % 1;
                                    break;
                            }
                        }
                        break;
                }
            }

            this.setState({ ...this.state, incomes: newIncomes });
        }

        startDate = yourPerson ? PersonService.getDieAge(yourPerson) : LocalDate.now().plusYears(50);
        endDate = startDate;
        await CardService.createCard(
            {
                description: 'end of life',
                startDate,
                endDate,
                attributes: {},
                accountId: null,
                startIncomes: [],
                modifyIncomes: [],
                createdBy: 'onboarding'
            },
            this.props.user,
            false,
            true
        );

        // delete old expenses if any
        const expenses = await RecurringExpenseService.getRecurringExpenses();
        for (const expense of expenses) {
            promises.push(RecurringExpenseService.deleteRecurringExpense(expense));
        }

        await Promise.all(promises);

        await this.props.handleReloadUser();

        if (this.props.user.attributes.startupJustMe) {
            await this.goto(StartupSteps.MEET_YOUR_PLAN);
        } else {
            await this.next();
        }

        $(PRIMARY_BUTTON_SELECTOR).prop('disabled', false);
    }

    private async makeExpenses(expenses: number, name: string = 'Recurring Expense'): Promise<void> {
        const lastYear: LocalDate = LocalDate.of(LocalDate.now().year() - 1, 1, 1);
        const recurringExpense: RecurringExpenseModel = new RecurringExpenseModel();
        recurringExpense.startDate = lastYear;
        recurringExpense.monthlyAmount = expenses;
        // Do not modify this without updating Elephant's "delete initial values after sync" StepZero code
        recurringExpense.name = name;
        recurringExpense.categories = 'Other';
        await RecurringExpenseService.createRecurringExpense(recurringExpense);
        await this.props.handleReloadUser();
    }

    private async setStartupSteps(): Promise<void> {
        const steps = [
            StartupSteps.WELCOME,
            StartupSteps.WHO,
            StartupSteps.WHOELSE,
            StartupSteps.MEET_YOUR_PLAN,
            StartupSteps.INCOMES,
            StartupSteps.EXPENSES,
            StartupSteps.CASH_AND_BANKING,
            StartupSteps.RETIREMENT,
            StartupSteps.PROPERTY_AND_ASSETS,
            StartupSteps.LOANS_AND_DEBTS,
            StartupSteps.DONE
        ];

        const attributes: any = this.props.user.attributes;
        attributes.startupSteps = steps;
        await this.props.handleUpdateUserAttributes(attributes);
        this.setState({
            startupSteps: steps
        });
    }

    private getLogin(isStep: boolean): JSX.Element {
        if (isStep && !this.props.user.temporary) {
            void this.next();
            return;
        }

        const securityUrl: string = HELP_DOMAIN ? HELP_DOMAIN + '/articles/data-security' : null;

        const helpLink: JSX.Element = HELP_DOMAIN ? (
            <Typography variant={TypographyVariants.CAPTION} key="security-info" className="security-info">
                <a href={securityUrl} target="_blank" rel="noopener noreferrer">
                    {LiteralsService.getLiteral('Onboarding.yourData')}
                </a>
            </Typography>
        ) : null;

        const privacy: JSX.Element = (
            <a href={PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
                {LiteralsService.getLiteral('Onboarding.privacy')}
            </a>
        );
        const terms: JSX.Element = (
            <a href={TERMS_AND_CONDITIONS} target="_blank" rel="noopener noreferrer">
                {LiteralsService.getLiteral('Onboarding.terms')}
            </a>
        );

        return (
            <>
                {isStep ? (
                    <>
                        <Typography variant={TypographyVariants.HEADING_L} className="title callout after8">
                            {LiteralsService.getLiteral('Onboarding.saveTabTitle')}
                        </Typography>
                        <Typography variant={TypographyVariants.SUBTEXT} className="weak after12">
                            {LiteralsService.getLiteral('Onboarding.saveTabDesc', [PRODUCT_NAME])}
                        </Typography>
                    </>
                ) : (
                    <Typography variant={TypographyVariants.HEADING_L} className="title callout after12">
                        {LiteralsService.getLiteral('Onboarding.saveTabTitle2', [PRODUCT_NAME])}
                    </Typography>
                )}

                <Typography variant={TypographyVariants.SUBTEXT} className="after12">
                    {LiteralsService.getLiteral('Onboarding.saveTabList0')}
                </Typography>

                <ul className="after32">
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT} className="callout">
                            {LiteralsService.getLiteral('Onboarding.saveTabList1')}
                        </Typography>
                    </li>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT} className="callout">
                            {LiteralsService.getLiteral('Onboarding.saveTabList2')}
                        </Typography>
                    </li>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT} className="callout">
                            {LiteralsService.getLiteral('Onboarding.saveTabList3')}
                        </Typography>
                    </li>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT} className="callout">
                            {LiteralsService.getLiteral('Onboarding.saveTabList4')}
                        </Typography>
                    </li>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT} className="callout">
                            {LiteralsService.getLiteral('Onboarding.saveTabList5')}
                        </Typography>
                    </li>
                    <li>
                        <Typography variant={TypographyVariants.SUBTEXT} className="callout">
                            {LiteralsService.getLiteral('Onboarding.saveTabList6')}
                        </Typography>
                    </li>
                </ul>

                <div className="row">
                    <Checkbox
                        value="checkedA"
                        className="callout-check"
                        checked={this.props.user.attributes.agreedToTerms || false}
                        onChange={() => {
                            const attributes = this.props.user.attributes;
                            attributes.agreedToTerms = !attributes.agreedToTerms;
                            this.props.handleUpdateUserAttributes(attributes);
                        }}
                    />
                    <Typography variant={TypographyVariants.SUBTEXT} className="block">
                        {LiteralsService.getLiteral('Onboarding.privacyTerms')} {terms} and {privacy}
                    </Typography>
                </div>

                <div className="buttons">
                    <ButtonSecondary
                        className="back-button"
                        onClick={async () => {
                            MixpanelService.track('o4 Save Plan Back');
                            await this.back();
                        }}
                    >
                        {LiteralsService.getLiteral('Onboarding.back')}
                    </ButtonSecondary>
                    {isStep ? (
                        <ButtonTertiary
                            className="skip-button"
                            id="skipForNow"
                            onClick={async () => {
                                MixpanelService.track('o4 Skip Registration');
                                await this.next();
                            }}
                        >
                            {LiteralsService.getLiteral('Onboarding.skip')}
                        </ButtonTertiary>
                    ) : null}
                </div>

                <Callout text={this.props.text} icon={<IconProcessing className="syncIcon" />} type="info">
                    <Typography variant={TypographyVariants.CAPTION}>
                        <b>
                            If you choose not to save your plan, you will lose anything you’ve added when you close this
                            app.
                        </b>
                    </Typography>
                </Callout>

                {helpLink}
            </>
        );
    }

    private async refreshPersons(): Promise<void> {
        const persons: PersonModel[] = await PersonService.getPersons();
        const drawerProps = {
            ...this.props.drawerProps,
            persons
        };
        this.props.updateDrawer(drawerProps);
    }

    private async welcomeNext(): Promise<void> {
        for (const goalName of this.state.startupGoals) {
            const goal: OnboardingGoal = _.find(onboardingGoals, { label: goalName });
            MixpanelService.track(goal.track);
        }
        MixpanelService.track('o4 Financial Goals Complete');
        await this.next();
    }

    private async nextAfterJustMe(): Promise<void> {
        MixpanelService.track('o4 Just Me Complete');
        await this.refreshPersons();
        await this.addGoals();
    }

    private async whoElseNext(): Promise<void> {
        MixpanelService.track('o4 Who Else Complete');
        $(PRIMARY_BUTTON_SELECTOR).prop('disabled', true);
        await this.addGoals();
    }
}
